import React, { Component } from 'react'
import './HomeStyle.css'
import Time from './Time'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import 'swiper/css';
import 'swiper/css/effect-fade';
import "swiper/css/navigation";
import "swiper/css/pagination";
import Slide1 from '../Images/Vote1.png'
import Slide2 from '../Images/Vote2.png'
import Slide3 from '../Images/Vote3.png'
import Slide4 from '../Images/Vote4.png'
import Image1 from '../Images/Image5.png'
import Image2 from '../Images/step-1.png'
import Image3 from '../Images/step-2.png'
import Image4 from '../Images/step-3.png'
import Image5 from '../Images/4380600.png'
import Image6 from '../Images/all-devices.png'
import Image7 from '../Images/ui.png'
import Image8 from '../Images/508312.png'
import Image9 from '../Images/users.png'
import Image10 from '../Images/otp.png'
import Image11 from '../Images/alert.png'
import Image12 from '../Images/automation.png'
import Image13 from '../Images/result.png'
import Image14 from '../Images/price.png'
import Image15 from '../Images/ImageV.png'

export default class Home extends Component {
  
  render() {
    return (
    <>
    <div className='swiper'>
    <Swiper
      spaceBetween={0}
      slidesPerView={1}
      speed={1000}
     autoplay={{
        delay: 3000,
        disableOnInteraction: false,}}
        pagination={{
          dynamicBullets: true,
          clickable:true,
        }}
        navigation={true}
        modules={[Autoplay, EffectFade, Navigation, Pagination]}
        effect="fade" >
      <SwiperSlide>
      <div className='S1'>
        <img src={Slide1} alt='slide' width='100%'></img>
        <div className='S1-1'>
            <div className='intro'><Time/><h2> </h2><h1> Welcome user, to eVoting Website</h1></div>
            <h3>Please give your valuable vote.</h3>
            {/* <Link to='/Login'>Vote</Link>    */}
        </div>
        <div className='S1-2'>
          <p>"Shape tomorrow by Voting Today!"</p>
        </div>
      </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className='S1'>
        <img src={Slide4} alt='slide' width='100%'></img>
        <div className='S1-3'>
            <h1>eVoting - Online Elections Simplified</h1>
            <h2>eVoting System is a robust blockchain-based online website that helps you conduct elections smoothly.</h2>        
        </div>
      </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className='S1'>
        <img src={Slide2} alt='slide' width='100%'></img>
        <div className='S1-4'>
            <h1>100% Secure, Blockchain-based Elections</h1>
            <h2>Adoption of Industry Standards data security measures ensures that the elections are secure and reliable.</h2>        
        </div>
      </div>
      </SwiperSlide>
      <SwiperSlide>
      <div className='S1'>
        <img src={Slide3} alt='slide' width='100%'></img>
        <div className='S1-5'>
            <h1>Any Time. Any Where. Any Device.</h1>
            <h2>Create and manage elections for your organization instantaneously on all internet-enabled devices.</h2>    
        </div>
        
      </div>
      </SwiperSlide>
    </Swiper>
    </div>


    <div className='S2' id='About'>
        <h1>About eVoting System</h1>
        <span>Revolutionizing online election system </span>
        <div className='S2-1'>
          <div className='S2Iamge'>
            <img src={Image1} alt='vote' width='100%'></img>
          </div>
          <div className='S2-2'>
            <p>eVoting System is an Blockchain-based election system that facilitates voters to record their secure and secret votes electronically. It has a friendly user interface and enables voters to cast their votes in few simple steps. 
              <br></br><br></br>We ensures the authenticity of the voters and the votes cast by them along with non-traceability of the casted vote. eVoting system's robust architecture has persistently manifested to be one of the most reliable, secure, comprehensible and economical electronic voting solution.
              <br></br><br></br>It renders Simple and Accessible voter experience that eventually increases voter engagement and turnout. Auditable, Easy To Use, Secure, Immutable and Reliable is what sets eVoting system apart from traditional voting system.
              <br></br><br></br>eVoting system can facilitated several organizations, across a wide range of industries to conduct hassle-free electronic voting with utmost security and integrity.
            </p>
          </div>
        </div>
    </div>

    <div className='S3' id='Working'>
      <h1>How it works</h1>
      <span>Conducting online election is a simple 3 step process.</span>
      <div>
        <div className='S3-1'>
          <div className='S3Img'>
            <img className='S3Img1' src={Image2} alt='steps' width='150px' height='150px'></img>
          </div>
          <div className='S3Text'>
            <h1>Set-up Election</h1>
            <p>On successful registration, with our effortless voting system, you can set-up election in no time. This process involves 2 steps:</p>
            <ul className='S3List'>
              <li>
                <h3>ADD ELECTION DETAILS</h3>
                <p>Add election details like election date, time and candidate’s names</p>
              </li>
              <li>
                <h3>REVIEW & LAUNCH</h3>
                <p>Once you've entered all the required details, review it and then you are good to go. Schedule a start/end date or immediately launch the election.</p>
              </li>
            </ul>
          </div>
        </div>
        <div className='S3-1'>
          <div className='S3Img'>
            <img src={Image3} alt='steps' width='150px' height='150px'></img>
          </div>
          <div className='S3Text'>
            <h1>Vote</h1>
            <p>SMS and E-mails are sent to your voters to notify them about the election link, clicking on which voters can record their vote through any internet-enabled device.</p>
          </div>
        </div>
        <div className='S3-1'> 
          <div className='S3Img'>
            <img src={Image4} alt='steps' width='150px' height='150px'></img>
          </div>
          <div className='S3Text'>
            <h1>Results</h1>
            <p>After the election ends, on approval of election officer, the results can be generated automatically. This is solely for security purposes. The outcome can be published and shared with the voters on the website.</p>
          </div>
        </div>
      </div>
    </div>

    <div className='S4' id='Features'>
      <h1>Features</h1>
      <span>Secure-Swift-Simple</span>
      <div className='S4Flexbox'>
      <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image5} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Dedicated Voting Website</h3>
            <p>Get a dedicated voting website for your organization.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image6} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Compatible with any device</h3>
            <p>It works seamlessly on all web browsers and internet-enabled devices like laptops, mobile phones, iPads, tablets etc</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image7} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Customization</h3>
            <p>Customize your elections as per your organization's requirements</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image8} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Immutable, Secure</h3>
            <p>As the eVoting system is based on Blockchain-Technology it provides immuatability which gives security and helps from tapering votes,etc.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image9} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Candidate information</h3>
            <p>The system allows you to add candidate information like their profile, photo and designation on the voting website.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'> 
            <img src={Image10} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Voters’ privacy & integrity</h3>
            <p>Security and confidentiality of the voter are taken very seriously. Voters can only vote once and their voting choices remain anonymous.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image11} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Increased voter turnout</h3>
            <p>SMS and E-mails are sent to your voters to notify them about the election. Reminders to vote are also sent.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image12} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Automated system</h3>
            <p>Since there are no error-prone manual processes, your voters can rest assured that their votes will be counted accurately and instantly.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image13} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Share and publish a result</h3>
            <p>Publish and share the outcome of the election with your voters on the website.</p>
          </div>
        </div>

        <div className='S4-1'>
          <div className='S4Img'>
            <img src={Image14} alt='feature' width='150px' height='150px'></img>
          </div>
          <div className='S4Text'>
            <h3>Economical</h3>
            <p>Apart from the above attributes, It renders a smooth and easy-to-use voter interface. This service can be available at an affordable and cost-effective price</p>
          </div>
        </div>

      </div>
    </div>


    <div className='S8'>
      <div className='S8-1'>
        <h1>Stop waiting, Start eVote-ing</h1>
        <div className='S8Text'>
          <a href='/Register' onClick={()=>{window.sessionStorage.setItem('selectedTab', JSON.stringify(6))}}>Register</a>
        </div>
      </div>
      <div className='S8Img'> 
        <img src={Image15} alt='vote' width='100%'></img>
      </div>
    </div>
    </>
    )
  }
}
